import { render, staticRenderFns } from "./ViewMethodEthicsAndConsent.vue?vue&type=template&id=2ecb6b5a"
import script from "./ViewMethodEthicsAndConsent.vue?vue&type=script&lang=js"
export * from "./ViewMethodEthicsAndConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports